/*eslint-disable*/
import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

const useStyles = makeStyles(styles);

export default function HeaderLeftLinks(props) {
  const classes = useStyles();

  const { handleDrawerToggle } = props;

  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Button
          href="#house"
          className={classes.navLink}
          color="transparent"
          onClick={handleDrawerToggle}
        >
          Alojamento
        </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Button
          href="#region"
          className={classes.navLink}
          color="transparent"
          onClick={handleDrawerToggle}
        >
          Região
        </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Button
          href="#location"
          className={classes.navLink}
          color="transparent"
          onClick={handleDrawerToggle}
        >
          Localização
        </Button>
      </ListItem>

      <ListItem className={classes.listItem}>
        <Button
          href="#contacts"
          className={classes.navLink}
          color="transparent"
          onClick={handleDrawerToggle}
        >
          Reservas
        </Button>
      </ListItem>
    </List>
  );
}
